export default __webpack_public_path__ + "static/media/Laser_Drivers_Controllers.5c3c093a.png";